var $63a9e532d9261d60$exports = {};
$63a9e532d9261d60$exports = {
    "clear": `Wyczy\u{15B}\u{107}`,
    "invalid": `(nieprawid\u{142}owy)`,
    "loading": `Trwa \u{142}adowanie...`,
    "noResults": `Brak wynik\xf3w`,
    "valid": `(wa\u{17C}ny)`
};


export {$63a9e532d9261d60$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
